import { memo } from 'react';
import PropTypes from 'prop-types';
// eslint-disable-next-line import/no-unresolved
import { SecondaryButton } from '@JohnLewisPartnership/jl-design-system/elements/button/Button';
import styles from './go-to-basket.module.scss';

const GoToBasket = ({
  disabled = false,
  goToBasket,
  veryShortCtaText = false,
}) => {
  const getButtonText = () => {
    if (veryShortCtaText) {
      return 'Basket';
    }
    return 'Go to basket';
  };

  return (
    <SecondaryButton
      data-testid="compare-go-to-basket-button"
      disabled={disabled}
      className={styles.compareGoToBasket}
      onClick={(e) => goToBasket(e)}
      tag="a"
      href="/basket"
    >
      {getButtonText()}
    </SecondaryButton>
  );
};

GoToBasket.propTypes = {
  disabled: PropTypes.bool,
  goToBasket: PropTypes.func,
  veryShortCtaText: PropTypes.bool,
};

export default memo(GoToBasket);
